import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { CajaMovimiento } from "@/shared/types/caja-movimiento";

export async function getCajaActualAperturaMovimiento(aperturaId: string, movimientoId: string): Promise<CajaMovimiento> {
    await sleep(1000);
    const response = await api.get("caja_actual/history/" + aperturaId + "/details/" + movimientoId);
    return response.data;
}

export function useGetCajaActualAperturaMovimientoQuery(aperturaId: string, movimientoId: string, queryConfig: QueryConfig<CajaMovimiento> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getCajaActualAperturaMovimiento(aperturaId, movimientoId),
        queryKey: ["caja_actual", "history", aperturaId, "details", movimientoId],
    })
}

export interface GetCajaActualAperturaMovimientoQueryProps {
    aperturaId: string,
    movimientoId: string,
    queryConfig?: QueryConfig<CajaMovimiento>,
    children?: (queryResult: QueryResult<CajaMovimiento>) => ReactNode
}

export function GetCajaActualAperturaMovimientoQuery({
    aperturaId,
    movimientoId,
    children,
    queryConfig
}: GetCajaActualAperturaMovimientoQueryProps) {
    const queryResult = useGetCajaActualAperturaMovimientoQuery(aperturaId, movimientoId, queryConfig);
    return children && children(queryResult);
}